import { environment } from '@ieEnv/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ActivityFormResponseDto,
  FormResponseDto,
} from 'shared-general-libs/dto/form';
import { FrameworkTags } from 'shared-general-libs/enum/framework';
import { Observable } from 'rxjs';
import {
  PhoneCodeResponseDto,
  RegionResponseDto,
} from 'shared-general-libs/dto/region';
import { ReportTemplate } from 'shared-general-libs/type/report';

@Injectable({
  providedIn: 'root',
})
export class FormRepository {
  private readonly apiUrl: string = environment.formHost;

  constructor(private http: HttpClient) {}

  getFormByName(name: string, payload: unknown): Observable<FormResponseDto[]> {
    return this.http.post<FormResponseDto[]>(
      `${this.apiUrl}/form/get/${name}`,
      payload,
    );
  }

  getReportTemplate(id: string): Observable<ReportTemplate> {
    return this.http.get<ReportTemplate>(
      `${this.apiUrl}/form/report-template/${id}`,
    );
  }

  getFormByActivityName(
    activity: string,
    frameworkTags?: FrameworkTags[],
  ): Observable<ActivityFormResponseDto> {
    // When the DCR's frameworkTags are supplied, form-service returns a form
    // filtered to those frameworks (if field filtering is enabled). Omitting
    // them yields the full, unfiltered form (admin preview / unconfigured DCR).
    const body = frameworkTags?.length ? { frameworkTags } : {};
    return this.http.post<ActivityFormResponseDto>(
      `${this.apiUrl}/form/get/activity/${activity}`,
      body,
    );
  }

  getRegions(lang: string): Observable<RegionResponseDto[]> {
    return this.http.get<RegionResponseDto[]>(
      `${this.apiUrl}/form/regions/${lang}`,
    );
  }

  getPhoneCodes(): Observable<PhoneCodeResponseDto[]> {
    return this.http.get<PhoneCodeResponseDto[]>(
      `${this.apiUrl}/form/phone-codes`,
    );
  }
}
